var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpicon = function SvgThumbsUpicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.975 7.56a2.25 2.25 0 0 0-1.725-.81h-3.42l.42-1.072A3.097 3.097 0 0 0 8.332 1.5a.75.75 0 0 0-.682.443L5.512 6.75H3.75A2.25 2.25 0 0 0 1.5 9v5.25a2.25 2.25 0 0 0 2.25 2.25h9.547a2.25 2.25 0 0 0 2.213-1.845l.952-5.25a2.25 2.25 0 0 0-.487-1.845zM5.25 15h-1.5a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 .75-.75h1.5V15zM15 9.135l-.953 5.25a.75.75 0 0 1-.75.615H6.75V7.658l2.04-4.59a1.582 1.582 0 0 1 1.035 2.085l-.397 1.072A1.5 1.5 0 0 0 10.83 8.25h3.42a.75.75 0 0 1 .578.27.75.75 0 0 1 .172.615z"
  })));
};
export default SvgThumbsUpicon;